import { Skeleton, Flex } from "antd";

export const DropDownListContentSkeleton = () => {
  const loading = true;

  return (
    <Flex align="center">
      <Skeleton.Avatar active size="large" />
      <Flex vertical className="ml-3 w-full">
        <Skeleton.Button
          active
          size="small"
          className="w-3/5"
          style={{ width: "60%" }}
        />
        <Skeleton.Input
          active
          size="small"
          className="w-4/5 mt-1"
          style={{ width: "100%" }}
        />
      </Flex>
    </Flex>
  );
};
